"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatorMergeService = void 0;
class CreatorMergeService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Merge creators by id
     * merge creator by using provided base or oldest twitch
     * @param requestBody
     * @returns CreatorMergeResponse
     * @throws ApiError
     */
    manualMergeCreators(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/creators/merge',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.CreatorMergeService = CreatorMergeService;
